import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import { pageCloseButtonSx } from "./managementPageLayout";

export default function PageCloseButton({ onClick, sx, ...props }) {
  const navigate = useNavigate();

  return (
    <IconButton
      onClick={onClick ?? (() => navigate("/"))}
      aria-label="Close"
      sx={{ ...pageCloseButtonSx, ...sx }}
      {...props}
    >
      <CloseIcon sx={{ fontSize: 18 }} />
    </IconButton>
  );
}
